import { ChangeEvent } from 'react';

export const FORM_FIRSTNAME_MAX_LENGTH = 30;
export const FORM_LASTNAME_MAX_LENGTH = 60;
export const FORM_PHONE_MAX_LENGTH = 15;
export const FORM_PHONE_EXT_MAX_LENGTH = 5;
export const FORM_GST_MAX_LENGTH = 20;
export const FORM_BUSINESS_NUMBER_MAX_LENGTH = 20;
export const FORM_RT_MAX_LENGTH = 5;

export const validatePhoneNumberFormat = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10); // Only numbers, max 10 digits

    // Format as "999-999-9999"
    let formattedValue = value;
    if (value.length > 6) {
        formattedValue = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
    } else if (value.length > 3) {
        formattedValue = `${value.slice(0, 3)}-${value.slice(3)}`;
    }

    e.target.value = formattedValue;
};

export const validatePostalCodeFormat = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    const cleanValue = value.replace(/[^A-Za-z0-9 ]/g, '');
    let formattedValue = '';
    let charCount = 0;
    let hasInsertedSpace = false;

    // Expected format is "ANA NAN"
    for (let i = 0; i < cleanValue.length; i++) {
        const char = cleanValue[i];
        if (charCount === 3) {
            // Allow useer to type a single space after first three digits
            if (char === ' ' && !hasInsertedSpace) {
                formattedValue += ' ';
                hasInsertedSpace = true;
                continue;
            } else if (/\d/.test(char) && !hasInsertedSpace) {
                formattedValue += ' '; // insert space if it was not added by user
                hasInsertedSpace = true;
            } else if (char === ' ') {
                continue;
            } else if (!/\d/.test(char)) {
                break;
            }
        }

        // Positions 0, 2, 4 must be letters
        if (charCount % 2 === 0) {
            if (/[A-Za-z]/.test(char)) {
                formattedValue += char;
            } else {
                break;
            }
        // Positions 1, 3, 5 must be numbers
        } else {
            if (/\d/.test(char)) {
                formattedValue += char;
            } else {
                break;
            }
        }
        charCount++;
        if (charCount === 6) break;
    }

    e.target.value = formattedValue;
}
